var _defs, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sqlBody",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4A90E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5C8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sqlTop",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6FB1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A90E2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sqlBody)",
    d: "M16 28v72c0 8.8 21.5 16 48 16s48-7.2 48-16V28z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 52,
    rx: 48,
    ry: 12,
    fill: "#2E5C8A",
    opacity: 0.55
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 76,
    rx: 48,
    ry: 12,
    fill: "#2E5C8A",
    opacity: 0.55
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 28,
    rx: 48,
    ry: 14,
    fill: "url(#sqlTop)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 28,
    rx: 48,
    ry: 14,
    fill: "none",
    stroke: "#1F4468",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 800,
    fontSize: 26,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 104,
    letterSpacing: 2
  }, "SQL"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.619115ad56cb7dbdb7248fa34066bcf7.svg";
export { ForwardRef as ReactComponent };